import React, { useState } from 'react';
import { connect } from 'react-redux';
import ValidationError from '../ValidationError';
import {updateUserAction} from "~/redux/actions/auth";
import TextTranslate, { TextTranslateString } from '../../TextTranslate/TextTranslate';
import classnames from 'classnames';
import { useEffect } from 'react';
import {
    saveGuestPersonalDetails,
} from "~/redux/actions/guests";

function ProfilePopupForm (props) {

    useEffect(()=>{
        setValues({
            first_name: props.user?.first_name,
            last_name: props.user?.last_name,
            email: props.user?.email,
            phone: props.user?.phone,
            company: props.user?.company,
        });
        setForm({
            first_name: props.user?.first_name,
            last_name: props.user?.last_name,
            email: props.user?.email,
            phone: props.user?.phone,
            company: props.user?.company,
        })
    }, [props.user])

    useEffect(()=>{
        if(props.guests) {
            setValues((prevState) => {
                return {
                    ...prevState,
                    job_title: props.guests[0]?.job_title
                }
            });
            setForm((prevState) => {
                return {
                    ...prevState,
                    job_title: props.guests[0]?.job_title
                }
            })
        }
    }, [props.guests])

    const [errors] = useState(props.errors || undefined);
    const [values, setValues] = useState({
        first_name: props.user?.first_name,
        last_name: props.user?.last_name,
        email: props.user?.email,
        phone: props.user?.phone,
        company: props.user?.company,
        job_title: ''
    });

    const defaultFields = {
        first_name:  '',
        last_name:  '',
        email: '',
        phone: '',
        company: '',
        job_title: '',
    };

    const [form, setForm] = useState({...defaultFields, ...values});

    const handleSubmit = () => {
        let promise = props.dispatch(updateUserAction(form));

        promise.then((data) => {
            if(props.guests[0].main) {
                props.dispatch(saveGuestPersonalDetails(props.guests[0].id, form))
            }
            props.setErrors(null);
            props.setSuccess(TextTranslateString('profile-updated-success', 'Success! User profile has been updated!', props.currentLanguage, props.translations));
        }).catch((error) => {
            props.setSuccess('');
            props.setErrors(error?.data);
        });
    };

    const handleChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;

        setForm({...form, [name]: value});
    };

    function renderSubmitButton () {
        if(props.isSeparatePage) {
            return (<button
                type="button"
                onClick={(e) => handleSubmit()}
                className="btn btn-primary text-uppercase mt-4 w-100"><TextTranslate name="word-save-changes" fallback="Save Changes" textOnly/>
            </button>)
        } else {
            return (<button
                type="button"
                onClick={(e) => handleSubmit()}
                className="btn btn-primary text-uppercase mt-auto btn-sm"><TextTranslate name="word-save-changes" fallback="Save Changes" textOnly/>
            </button>)
        }
    }

	return (
		<form>
            <div className="form-row">
                <div
                    className={classnames([
                        "form-group",
                        "col-md-6",
                        "pr-sm-1 pr-lg-2"
                    ])}
                >
                    <label><TextTranslate name="user-first-name" fallback="First Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.first_name || ''}
                        name="first_name"
                        type="text"
                        className="form-control"/>

					<ValidationError errors={errors} name="first_name" />
                </div>
                <div className="form-group col-md-6 pl-sm-1 pl-lg-2">
                    <label><TextTranslate name="user-last-name" fallback="Last Name"/></label>
                    <input
                        onChange={handleChange}
                        value={form.last_name || ''}
                        name="last_name"
                        type="text"
                        className="form-control"/>

					<ValidationError errors={errors} name="last_name" />
                </div>
            </div>
            <div className="form-group disabled">
                <label><TextTranslate name="user-email-address" fallback="Email Address"/></label>
                <input
                    disabled={true}
                    onChange={handleChange}
                    value={form.email || ''}
                    name="email"
                    type="text"
                    className="form-control"/>

				<ValidationError errors={errors} name="email" />
            </div>
            <div className="form-group">
                <label className="d-block mb-0"><TextTranslate name="user-phone-number" fallback="Phone Number"/></label>
                <span className="text-caption-1 text-color-gray d-block m-0 mb-2">
                    <TextTranslate name="form-phone-note" fallback="Please include area code."/>
                </span>
                <input
                    onChange={handleChange}
                    value={form.phone || ''}
                    name="phone"
                    type="text"
                    placeholder="(+44)-XXX-XXX-XXX"
                    className="form-control"/>

				<ValidationError errors={errors} name="phone" />
            </div>
            {renderSubmitButton()}
        </form>
	)
}

const mapStateToProps = (state) => ({
    user: state.auth?.user,
    currentLanguage: state.translations?.currentLanguage,
    translations: state.translations?.translations,
    guests: state.guests?.list,
});

export default connect(mapStateToProps)(ProfilePopupForm);
